// src/components/MDBox.jsx
import React from 'react';
import { Box } from '@mui/material';

function MDBox({ children, ...props }) {
  return (
    <Box {...props}>
      {children}
    </Box>
  );
}

export default MDBox;